/**
 * @module svg
 */

/**
 * @typedef {object} EncodeOptions
 * @property {boolean} replaceDoubleQuotes - Boolean flag denoting whether or not to replace double quotes with single quotes.
 * @property {boolean} replaceSingleQuotes - Boolean flag denoting whether or not to replace single quotes with double quotes.
 */

const symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;

/**
 * Convenience function to add namespace to the specified SVG data, as needed.
 *
 * @param {string} data - The SVG data string.
 * @param {string} quoteType - The quote type, either `"` or `'`.
 *
 * @returns {string} The SVG data string with namespace added, as needed.
 */
function addNameSpace(data, quoteType) {
  let convertedData = data;
  if (convertedData.indexOf(`http://www.w3.org/2000/svg`) < 0) {
    convertedData = convertedData.replace(
      /<svg/g,
      `<svg xmlns=${quoteType}http://www.w3.org/2000/svg${quoteType}`,
    );
  }
  return convertedData;
}

/**
 * Convenience function to encode the specified SVG data string to a format suitable for use as img src.
 *
 * @param {string} data - The SVG data string.
 * @param {EncodeOptions} options - Object of encode options.
 *
 * @see {@link https://yoksel.github.io/url-encoder/}.
 *
 * @returns {string} The encoded SVG data string.
 */
function encodeSVG(
  data,
  options = { replaceDoubleQuotes: true, replaceSingleQuotes: false },
) {
  let convertedData = addNameSpace(
    data,
    !options || options.replaceDoubleQuotes ? '"' : "'",
  );

  // Convert quote type to avoid encoding.
  if (!options || options.replaceDoubleQuotes) {
    convertedData = convertedData.replace(/"/g, `'`);
  }
  if (options && options.replaceSingleQuotes) {
    convertedData = convertedData.replace(/'/g, `"`);
  }

  convertedData = convertedData.replace(/>\s{1,}</g, `><`); // NOSONAR
  convertedData = convertedData.replace(/\s{2,}/g, ` `); // NOSONAR

  // Using encodeURIComponent() as replacement function allows resulting code readability.
  return convertedData.replace(symbols, encodeURIComponent);
}

module.exports = {
  encodeSVG,
};
